import moment from 'moment';
import i18n from '../i18n.js';

export default {

    saveState(state){
        return state.saveState;
    },

    currentSearchTerm: (state) => {
        return state.searchTerm;
    },

    currentRouteVerbose: (state, getters) => route => {
        if(!getters.userIsAuthenticated){
            return '';

        } else if(route.name === 'settings'){
            return i18n.t('app.setting');
        } else if(route.name === 'application-list') {
            return i18n.t('app.title_application');
        } else {
            // TODO
            let currentRouteVerbose = 'Application ';
            if(state.currentApplication){
                currentRouteVerbose += `/ ${state.currentApplication.label}`;
            }
            if(state.currentInstance){
                currentRouteVerbose += `/ ${state.currentInstance.label}`;
            }
            return currentRouteVerbose;
        }
    },

    getCurrentApplication (state){
        return state.currentApplication;
    },
    getCurrentApplicationTab (state){
        return state.currentApplicationTab;
    },
    currentApplicationEmpty (state){
        return Object.keys(state.currentApplication).length === 0;
    },
    getSnackbarState(state) {
        return state.snackbar;
    },
    displaySnackbar(state) {
        return state.displaySnackbar;
    },
    getWw (state){
        return state.ww;
    },

    userIsAuthenticated (state){
        return state.api.auth.user.authenticated;
    },

    /////////////////////////// APP GETTERS ///////////////////////////

    listDatatype (){
        return [
            {
                text: 'bool',
                value: 'bool'
            },
            {
                text: 'txt',
                value: 'txt'
            },
            {
                text: 'char',
                value: 'char'
            },
            {
                text: 'url',
                value: 'url'
            },
            {
                text: 'int',
                value: 'int'
            },
            {
                text: 'bigint',
                value: 'bigint'
            },
            {
                text: 'uid',
                value: 'uid'
            },
            {
                text: 'float',
                value: 'float'
            },
            {
                text: 'decimal',
                value: 'decimal'
            },
            {
                text: 'json',
                value: 'json'
            },
            {
                text: 'file',
                value: 'file'
            },
            {
                text: 'image',
                value: 'image'
            },
            {
                text: 'datetime',
                value: 'datetime'
            },
            {
                text: 'date',
                value: 'date'
            },
            {
                text: 'email',
                value: 'email'
            },
            {
                text: 'ip',
                value: 'ip'
            },
            {
                text: 'point',
                value: 'point'
            },
            {
                text: 'foreign_key',
                value: 'fk'
            },
            {
                text: 'many_to_many',
                value: 'm2m'
            },
            // {
            //     text: 'one_to_one',
            //     value: 'o2o'
            // },
        ].sort((a,b) => {
            if(a.text < b.text ) return -1;
            if(a.text > b.text ) return 1;
            else return 0;
        },);
    },

    listRelDatatype (){
        return ['fk', 'm2m'];  //'o2o'
    },

    getSessionUid() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    },

    currentOrganisation (state, getters){
        if(!getters.currentUser.hasOwnProperty('organizations') || getters.organizations.length === 0) return;
        return getters.organizations.find((org) => org.uid === getters.currentUser.organizations[0]);
    },

    initialDataLoaded (state, getters){
        return getters.currentUser.hasOwnProperty('organizations') === true && state.api.modelsFlagLoaded.organizations;
    },
    runningInstances (state, getters){
        if(!getters.organizationData[0]) return 'NA';
        return getters.organizationData[0].running_instances;
    },
    allowedInstances (state, getters){
        if(!getters.organizationData[0]) return 'NA';
        return getters.organizationData[0].allowed_instances;
    },
    maxRunningInstancesReached (state, getters){
        if(!getters.organizationData[0]) return false;
        return getters.runningInstances >= getters.allowedInstances;
    },
    reservedKeyWords (){
        return ['False', 'None', 'True', 'and', 'as', 'assert', 'break', 'class', 'continue', 'def', 'del', 'elif', 'else', 'except', 'finally', 'for', 'from', 'global', 'if', 'import', 'in', 'is', 'lambda', 'nonlocal', 'not', 'or', 'pass', 'raise', 'return', 'try', 'while', 'with', 'yield'];
    },
    reservedFieldNames (){
        return ['uid', 'modification_date', 'creation_date', 'public', 'created_by', 'can_admin_users', 'can_view_users', 'can_admin_groups', 'can_view_groups', 'additional_filtering'];
    },
    reservedUserFieldNames (){
        return ['admin', 'password_modification_date', 'password_modification_token', 'subscription_notification_token', 'login_counter', 'unsubscribe_all', 'unsubscribe_to'];
    },
    datamodelDetailedError: (state) => (keyError) => {
        return state.datamodelDetailedError[keyError];
    },
    modelsWithError (state){
        return state.modelsWithError;
    },
    modelsHasErrors (state){
        return state.modelsWithError.length > 0;
    },
    modelHasError: (state) => targetModelUid => {
        return state.modelsWithError.findIndex((model) => {
            return model.modelUid === targetModelUid;
        }) >= 0;
    },
    fieldInModelHasError: (state) => data => {
        return state.modelsWithError.findIndex((model) => {
            return model.modelUid === data.modelUid && model.provisionalFieldUid === data.provisionalFieldUid;
        }) >= 0;
    },
    managerUrl (){
        return window.config.manager_url;
    },
    actionsToWatchForCreateLog () {
        return ['createItem', 'patchItem', 'changeUserPassword', 'selfResetUserPassword'];
    },
    enableRegister(){
        return true;
    },
    freeVersion(state){
        return state.freeVersion;
    },
    concreteSite(state){
        return state.concreteSite;
    },
};




// WEBPACK FOOTER //
// ./src/store/getters.js